import { render, staticRenderFns } from "./Game_MainQuizInfo.vue?vue&type=template&id=e7469750&scoped=true&"
import script from "./Game_MainQuizInfo.vue?vue&type=script&lang=js&"
export * from "./Game_MainQuizInfo.vue?vue&type=script&lang=js&"
import style0 from "./Game_MainQuizInfo.vue?vue&type=style&index=0&id=e7469750&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7469750",
  null
  
)

export default component.exports